// App.js
import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { auth } from './firebaseConfig';
import { onAuthStateChanged } from 'firebase/auth';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import UserWithdrawalForm from './components/registration/UserWithdrawalForm';
import RegistrationCompleted from './components/registration/RegistrationCompleted';

const ProtectedRoute = ({ element, authenticated }) => {
  return authenticated ? element : <Navigate to="/admin-login" replace />;
};

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setIsAuthenticated(!!user);
      setLoading(false);
    });

    // Cleanup subscription on unmount
    return () => unsubscribe();
  }, []);

  if (loading) {
    return <div className="loading-screen">Loading...</div>; // Add custom loading UI if needed
  }

  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route path="/admin-login" element={<AdminLogin />} />
        <Route path="/withdrawal-form" element={<UserWithdrawalForm />} />
        <Route path="/registration-completed" element={<RegistrationCompleted />} />
        
        {/* Protected Routes */}
        <Route
          path="/admin-dashboard/*"
          element={<ProtectedRoute element={<AdminDashboard />} authenticated={isAuthenticated} />}
        />
        
        {/* Default Route */}
        <Route path="/" element={<Navigate to="/admin-login" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
